// @flow

import PropTypes from 'prop-types';
import type { hoverHandlersType } from 'app/common/lib/react/hoverable';
import type { ImageType } from 'app/common/react/components/profile/ProfileBoardCard/commonTypes';

export const ShowcaseArticleProps = PropTypes.shape({
  cover_images: PropTypes.arrayOf(
    PropTypes.shape({
      '564x': PropTypes.shape({
        height: PropTypes.number,
        url: PropTypes.string.isRequired,
        width: PropTypes.number,
      }),
    }),
  ),
  id: PropTypes.string.isRequired,
  title: PropTypes.shape({
    format: PropTypes.string.isRequired,
  }),
  subtitle: PropTypes.shape({
    format: PropTypes.string.isRequired,
  }),
});

export const ShowcaseBoardProps = PropTypes.shape({
  access: PropTypes.arrayOf(PropTypes.string),
  cover_images: PropTypes.objectOf(
    PropTypes.shape({
      url: PropTypes.string,
    }),
  ),
  has_custom_cover: PropTypes.bool,
  id: PropTypes.string,
  image_cover_hd_url: PropTypes.string,
  image_cover_url: PropTypes.string,
  images: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        dominant_color: PropTypes.string,
        height: PropTypes.number,
        url: PropTypes.string,
        width: PropTypes.number,
      }),
    ),
  ),
  name: PropTypes.string,
  pin_count: PropTypes.number,
  type: PropTypes.string,
  url: PropTypes.string,
});

export const ShowcaseBoardPickerProps = PropTypes.shape({
  id: PropTypes.string.isRequired,
  image_cover_url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

export const ANIMATION_DIRECTION: { LEFT: 'animateLeft', RIGHT: 'animateRight' } = {
  LEFT: 'animateLeft',
  RIGHT: 'animateRight',
};

/** ************************************
  Flow Types
**************************************/

export type AnimationDirection = 'animateLeft' | 'animateRight';

type CoverImageType = {
  '564x': {
    height?: number,
    url: string,
    width?: number,
  },
};

export type ShowcaseArticleType = {
  cover_images: Array<CoverImageType>,
  id: string,
  subtitle: {
    format: string,
  },
  title: {
    format: string,
  },
  type: 'explorearticle',
};

export type ShowcaseBoardType = {
  access: Array<string>,
  has_custom_cover: boolean,
  id: string,
  image_cover_hd_url: string,
  image_cover_url: string,
  images: { [key: string]: Array<ImageType> },
  name: string,
  pin_count: number,
  type: 'board',
  url: string,
};

export type ShowcaseShopType = {
  hoverHandlers: hoverHandlersType,
  id: string,
  isHovering: boolean,
  layout_params: {
    action_text: string,
    subtitle: string,
    title: string,
  },
  link_data: {
    id: string,
  },
  pins: Array<{ image_large_url: string }>,
  type: 'shop_recommendation_collection',
};

export type ArticlePickerType = {
  cover_images: Array<{
    '90x90': {
      url: string,
    },
  }>,
  id: string,
  title: {
    format: string,
  },
};

export type BoardPickerType = {
  id: string,
  image_cover_url: string,
  name: string,
};

export type ShowcaseSectionType = ShowcaseArticleType | ShowcaseBoardType | ShowcaseShopType;
